require ('./hireAdvInterstitialPromotionError.scss');

// @ vendors
const React = require('react');
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class HireAdvInterstitialPromotionError extends React.Component {

    render () {
        const errorMessage = formatText('hireAdvInterstitialPromotionError-hireAdvInterstitialPromotionError_title');
        const mainButton = {
            label: formatText('hireAdvInterstitialPromotionError-hireAdvInterstitialPromotionError_backButtonLabel'),
            url: '/myprofile/edit'
        };

        return (
            <div className="row grid-view--content-position-negative">
                <section className="col-xs-offset-2 col-xs-8 hire-adv-interstitial-promotion-error">
                    <WizardError
                        errorMessage={errorMessage}
                        mainButton={mainButton}
                    >
                        <div className="hire-adv-interstitial-promotion-error__caption">
                            <FormattedText value="hireAdvInterstitialPromotionError-hireAdvInterstitialPromotionError_detailTitle" />
                        </div>
                    </WizardError>
                </section>
            </div>
        );
    }
}

module.exports = HireAdvInterstitialPromotionError;